/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/travelInformation/flightScheduleResults.js
*    TO   --> ./legacy-web/src/main/assets/js/travel-information/flight-schedule-results.js
**/

AAcom('browserdetect', 'utilities', 'ajax', 'aaBusy', 'aaSwiper', 'commonsetup', 'notification', 'viewAvailableSeatsDialog', function(AAUI) {
    $j(function() {

        AAUI.initNotification(".createNotificationClass");

    	if (('localStorage' in window) && window.localStorage !== null) {
    	    if ('moreFlights' in localStorage && $j("#moreFlightsExpanded").val()=='true') {
                $j("#showMoreFlightsDivider").hide();
                $j("#showMoreFlightsButtonSection").hide();
                $j("#resultsTableBody").html(localStorage.getItem('moreFlights'));
    	    }
    	}

    	AAUI.onClick('.seatMaplink button', function() {
            AAUI.openVASDialog($j(this).data('seatslink'));
    	});

    	AAUI.onClick("#moreFlightsBtn", function() {
            $j.ajax({
                async : true,
                type : "GET",
                url : 'moreflights',
                dataType : "html",
                data : {},
                cache : false,
                timeout : 50000,
                success : function(response) {
                    $j("#resultsTableBody").append(response);
                    $j("#showMoreFlightsDivider").hide();
                    $j("#showMoreFlightsButtonSection").hide();
                    $j("#newFSResult").focus();
                    $j("#moreFlightsExpanded").val('true');
                },
                error : function(x, status, msg) {
                    //alert("Error:" + msg);
                }
            });
    	});
    });

	$j(window).unload(function () {
	    if (('localStorage' in window) && window.localStorage !== null) {
	        var form = $j("#resultsTableBody").html();
	        localStorage.setItem('moreFlights', form);
	    }
	});
});
